import script from "./Income.vue?vue&type=script&setup=true&lang=ts"
export * from "./Income.vue?vue&type=script&setup=true&lang=ts"

import "./Income.vue?vue&type=style&index=0&id=35af0e8a&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35af0e8a"]])

export default __exports__